module.exports = __webpack_public_path__ + "static/img/third2_1_6_active.3aaae961.jpg";